import decorativeSlide1 from '#app/assets/images/decorative/decorative-slide1.png'
import decorativeSlide2 from '#app/assets/images/decorative/decorative-slide2.png'
import decorativeSlide3 from '#app/assets/images/decorative/decorative-slide3.png'

export const slides = [
	{
		id: 'slide-1',
		title: 'Avanza hacia un futuro seguro',
		subtitle: 'Donde tu protección y la del mundo se encuentran',
		backgroundImage: '/img/home-hero-bg.png',
		decorativeImage: decorativeSlide1,
	},
	{
		id: 'slide-2',
		title: 'Construí un mañana más seguro desde hoy',
		subtitle: 'Sostenibilidad es acción diaria',
		backgroundImage: '/img/sostenibilidad-hero-bg.png',
		decorativeImage: decorativeSlide2,
	},
	{
		id: 'slide-3',
		title: 'Conectamos seguridad y sostenibilidad',
		subtitle: 'Más que seguros, decisiones conscientes',
		backgroundImage: '/img/conectamos-hero-bg.png',
		decorativeImage: decorativeSlide3,
	},
]

export const slidesTechnology = [
	{
		id: 'slide-tech-1',
		title: 'Acompañando\n' + 'la innovación digital',
		subtitle: 'Mejorar procesos, operaciones y la atención a clientes',
		backgroundImage: '/img/tecnologia-desktop.jpg',
		decorativeImage: decorativeSlide1,
	},
]

export const slidesSeguros = [
	{
		id: 'slide-seguros-1',
		title: 'Construí un mañana más seguro desde hoy',
		subtitle: 'Sostenibilidad es acción diaria',
		backgroundImage: '/img/sostenibilidad-hero-bg.png',
		decorativeImage: decorativeSlide2,
	},
]
export const slidesProposito = [
	{
		id: 'slide-proposito-1',
		title: 'Pensamos globalmente y actuamos localmente',
		subtitle: 'Cuidemos la casa donde vivimos, por un cambio real',
		backgroundImage: '/img/bg-proposito.png',
		decorativeImage: decorativeSlide1,
	},
]
export const slidesProgramaMadre = [
	{
		id: 'slide-programa-madre-1',
		title: 'Educa ConCiencia',
		subtitle: 'Transformar realidades desde las aulas',
		backgroundImage: '/img/programa-madre/bg-programa-madre.png',
		decorativeImage: decorativeSlide1,
	},
]

export const slidesFondoDeAgua = [
	{
		id: 'slide-fondo-agua-1',
		title: 'Fondo de agua del Río Mendoza',
		subtitle: 'El primer fondo de agua de la Argentina',
		backgroundImage: '/img/fondo-de-agua/bg-fondo-de-agua.png',
		decorativeImage: decorativeSlide1,
	},
]
